"use strict";
import React from "react";
import PropTypes from "prop-types";
import FormsyFields from "../formsyFields";
import Formsy from "../formsy";
import StyledCheckbox from '../styledCheckbox';
import { getPhoneValidation, parsePhone } from "../../util/validationUtils";

const initComponent = (flex = window.flex, FlexApiRequest = window.FlexApiRequest) => {

    class ContactMe extends React.PureComponent {
        static contextTypes = {
            formHandler: PropTypes.object
        };

        state = {
            canSubmitContactMe: false
        };

        componentWillUnmount() {
            this.unmounting = true;
        }

        componentDidMount() {
            const formHandler = this.context.formHandler || {};
            formHandler.onSubmit = this.onSubmit;
            formHandler.canSubmit = (canSubmit) => this.setState({ canSubmit: canSubmit });
            this.unmounting = false;
        }

        sendUnverifiedIdentifierPost = (model) => {
            const { orgId, userId, personId, appOrgId } = this.props;

            const parsedPhone = parsePhone(model.phone);

            const params = {
                orgId,
                userId,
                personId,
                appOrgId,
                dealerEmail: model.email,
                dealerPhone: parsedPhone,
                dealerAddressLine1: model.line1,
                dealerAddressLine2: model.line2,
                dealerCity: model.city,
                dealerStateOrRegion: model.stateOrRegion,
                dealerPostalCode: model.postalCode
            };

            return FlexApiRequest.POST({
                path: '/api/v1/org/sendunverifiedidentifierpost'
            }).send(params);
        }

        onContactMethodChange = (values) => {
            this.setState({
                canSubmitContactMe: values.email_chk || values.phone_chk
            });
        }

        handleContactsSubmit = (event) => {
            this.sendUnverifiedIdentifierPost(event).then(
                () => flex.addPageAlerts({ className: 'alert-success', summary: 'A Client Care representative will contact you shortly to verify your credentials.  You will still have access to the site, but your ability to purchase will be limited until your AuctionACCESS ID has been verified.', selfCloseTimeout: 10000 })
            ).catch(
                () => flex.addPageAlerts({ className: 'alert-warning', summary: 'Something went wrong. A Client Care representative will contact you shortly to verify your credentials.  You will still have access to the site, but your ability to purchase will be limited until your AuctionACCESS ID has been verified.', selfCloseTimeout: 10000 })
            );
        }

        render() {
            const formProps = { layout: 'vertical' };

            const phoneValidation = getPhoneValidation();

            return (
                <div>
                    <h2>Please specify how you would like us to contact you:</h2>
                    <Formsy.Form style={{ textAlign: 'left' }} onChange={this.onContactMethodChange} onValidSubmit={this.handleContactsSubmit}>
                        <fieldset>
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="checkbox-group">
                                        <StyledCheckbox
                                            {...formProps}
                                            id="email_chk"
                                            name="email_chk"
                                            defaultChecked={false}
                                            value={false}
                                            label={flex.text('UX_LOGIN_LBL_EMAIL')}
                                        >
                                        </StyledCheckbox>
                                    </div>
                                </div>
                                <div className="col-sm-5">
                                    <FormsyFields.Input {...formProps} id="email" name="email" placeholder={flex.text('UX_LOGIN_LBL_EMAIL')}
                                        type="email" validations="isEmail" validationError="Please enter a valid email address" />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="checkbox-group">
                                        <StyledCheckbox
                                            {...formProps}
                                            id="phone_chk"
                                            name="phone_chk"
                                            defaultChecked={false}
                                            value={false}
                                            label="Phone"
                                        >
                                        </StyledCheckbox>
                                    </div>
                                </div>
                                <div className="col-sm-5">
                                    <FormsyFields.Input 
                                        {...formProps} 
                                        id="phone" 
                                        name="phone"
                                        placeholder="Phone" 
                                        validations={phoneValidation.validations} 
                                        validationErrors={phoneValidation.validationErrors} 
                                    />
                                </div>
                            </div>

                        </fieldset>
                        <h2>Provide an address to better help us locate your account:</h2>
                        <fieldset>
                            <div className="row"><div className="col-sm-6"><FormsyFields.Input {...formProps} id="line1" name="line1" label="Address Line 1" placeholder="Address Line 1" type="text" required={true} /></div></div>
                            <div className="row"><div className="col-sm-6"><FormsyFields.Input {...formProps} id="line2" name="line2" label="Address Line 2" placeholder="Address Line 2" type="text" /></div></div>
                            <div className="row"><div className="col-sm-6"><FormsyFields.Input {...formProps} id="city" name="city" label="City" placeholder="City" type="text" required={true} /></div></div>
                            <div className="row"><div className="col-sm-6"><FormsyFields.Input {...formProps} id="stateOrRegion" name="stateOrRegion" label="State or Region" placeholder="State or Region" type="text" required={true} /></div></div>
                            <div className="row"><div className="col-sm-6"><FormsyFields.Input {...formProps} id="postalCode" name="postalCode" label="Postal Code" placeholder="Postal Code" type="text" required={true} /></div></div>
                        </fieldset>

                        <div className="bottom-actions">
                            <div className="row">
                                <div className="col-xs-12 col-sm-6 col-md-4">
                                    <button className="btn ladda-button" loading={flex.isBusy('orgItemSave')} type="submit" disabled={!this.state.canSubmitContactMe}>{flex.text('UX_ACT_CONTACT_ME')}</button>
                                </div>
                            </div>
                        </div>
                    </Formsy.Form>
                </div>);
        }
    }

    return ContactMe;
}

module.exports = initComponent;